<template functional>
  <tbody>
    <slot />
  </tbody>
</template>

<script>
export default {
    name: 'BaseTableGroup',
};
</script>
